// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2zqKD","box":"WorkspacesBox_box__3P6ZK","node":"WorkspacesBox_node__2Z0tT"};